import React, { useState, useEffect } from "react";
import api from "../../axios/api";
import Grid from "../common/Grid";

const InteractiveTable = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountryStats = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/upload/country-stats');
        setStats(response.data || []);
      } catch (error) {
        console.error("Error fetching country stats", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountryStats();
  }, []);

  // Function to calculate totals
  const totalPlants = stats.reduce((sum, r) => sum + parseInt(r.total_plants || 0, 10), 0);
  const verifiedPlants = stats.reduce((sum, r) => sum + parseInt(r.verified_plants || 0, 10), 0);

  const columns = [
    {
      header: "States",
      accessor: "state",
      sortable: true,
      align: "left",
    },
    {
      header: "Plants",
      accessor: "total_plants",
      sortable: true,
      align: "center",
      render: (val) => val ?? 0,
    },
    {
      header: "Verified",
      accessor: "verified_plants",
      sortable: true,
      align: "center",
      render: (val) => val ?? 0,
    },
  ];

  return (
    <div style={{ padding: '30px 20px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px', color: '#002F43' }}>States</h1>
      <Grid
        columns={columns}
        data={stats}
        loading={loading}
        variant="navy"
        rowKey="state"
        footer={[
          { content: 'Total', align: 'left', style: { fontWeight: 'bold',color:'black' } },
          { content: totalPlants, align: 'center', style: { fontWeight: 'bold',color:'black' } },
          { content: verifiedPlants, align: 'center', style: { fontWeight: 'bold',color:'black' } },
        ]}
      />
    </div>
  );
};

export default InteractiveTable;